import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field } from "formik";
import Yup from "yup";
import { CustomInput, ErrorField } from 'components/form';
import { passwordResetWorker } from 'ducks/auth/actions';
import logo from 'assets/images/im_logo2.png';
import logo2 from 'assets/images/logo2.svg';
import { Trans, withTranslated } from "components";

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
    })
  }).isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  reset: PropTypes.func.isRequired,
};

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;

    this.initialData = {
      email: "",
    };

    this.validationSchema = Yup.object().shape({
      email: Yup.string().required(t('To pole jest wymagane')),
    });

    this.state = { success: false };
  }

  handleSubmit = async (values, { setErrors, setSubmitting }) => {
    try {
      await this.props.reset(values);
      this.setState({ success: true });
    } catch({ error }) {
      setErrors(error);
      setSubmitting(false);
    }
  }

  render() {
    if(this.state.success) return <SuccessPanel />;

    return (
      <Formik
        initialValues={this.initialData}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ errors, handleSubmit, isSubmitting }) => (
          <div className="body login-page-wrapper">
            <div className="image-container">
              <div className="im-logo-container">
                <img src={logo} alt="" />
              </div>
            </div>
            <div className="form-container">
              <div className="form-container-inner">
                <div className="form-heading">
                  
                  <h3><Trans>Odzyskiwanie hasła</Trans></h3>
                  <h5>innovative thinking, global perspective</h5>
                </div>
                <form action="#" onSubmit={handleSubmit}>
                  <Field name="email" label="email" type="email" component={CustomInput} />
                  <div className="btn-container">
                    <button className="full-btn" type="submit" disabled={isSubmitting}>
                      <Trans>Wyślij</Trans>
                    </button>
                  </div>
                  <ErrorField text={errors.message} />
                </form>
              </div>
              <div className="copyrights">
                <a href="https://kivy.pl">
                  <span className="copyrights-text">Created by</span><span className="kivy-logo"><img src={logo2} alt="" /></span>
                </a>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapDispatch = {
  reset: passwordResetWorker,
};

PasswordReset.propTypes = propTypes;
const enhance = compose(
  connect(null, mapDispatch),
  withTranslated,
);

export default enhance(PasswordReset);


const SuccessPanel = () => (
  <div className="body login-page-wrapper">
    <div className="image-container">
      <div className="im-logo-container">
        <img src={logo} alt="" />
      </div>
    </div>
    <div className="form-container">
      <div className="form-container-inner">
        <div className="form-heading">
          
          <h3><Trans>Odzyskiwanie hasła</Trans></h3>
          <h5>innovative thinking, global perspective</h5>
          <h5><Trans>Na podany adres email została wysłana wiadomość. Proszę postępować według zawartych w niej instrukcji.</Trans></h5>
        </div>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/pages/password/Reset.jsx